module.exports = __webpack_public_path__ + "media/images/front/common/userIcon_scholarship-70c5607742e57c9153672acf1d3a740c.png";